import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

// Compact avatar button that opens an account dropdown. Used in the app nav
// and the landing header so the menu is consistent everywhere.
export default function AccountMenu({ showTools = true }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("touchstart", onDoc);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("touchstart", onDoc); };
  }, [open]);

  if (!user) return null;
  const name = user.display_name || user.username;
  const initial = name.charAt(0).toUpperCase();

  const go = (fn) => () => { setOpen(false); fn(); };

  return (
    <div ref={ref} className="llh-menu-wrap">
      <button onClick={() => setOpen((o) => !o)} aria-label="Account menu" className="llh-avatar-btn">
        <span className="llh-avatar">{initial}</span>
        <span className="llh-dim-11">▾</span>
      </button>

      {open && (
        <div className="llh-menu">
          <div className="llh-menu-head">
            <div className="llh-menu-name">{name}</div>
            <div className="llh-meta">{user.email}</div>
          </div>
          <button className="llh-menu-item" onClick={go(() => nav("/account"))}>Account</button>
          {user.role === "admin" && <button className="llh-menu-item" onClick={go(() => nav("/admin/overview"))}>Coaching</button>}
          {user.role === "admin" && <button className="llh-menu-item" onClick={go(() => nav("/admin"))}>Admin Panel</button>}
          {showTools && <button className="llh-menu-item" onClick={go(() => nav("/"))}>Back to tools</button>}
          <button className="llh-menu-item llh-menu-item--danger" onClick={go(logout)}>Sign out</button>
        </div>
      )}
    </div>
  );
}
